module.exports = __webpack_public_path__ + "img/section7-index.07523b13.png";